import script from "./export-debug-log.vue?vue&type=script&setup=true&lang=ts"
export * from "./export-debug-log.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__